import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Clock = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6ZM4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20ZM20 10C20.5523 10 21 10.4477 21 11V19.4338L25.5145 22.1425C25.9881 22.4267 26.1416 23.0409 25.8575 23.5145C25.5733 23.9881 24.9591 24.1416 24.4855 23.8575L19.4855 20.8575C19.1843 20.6768 19 20.3513 19 20V11C19 10.4477 19.4477 10 20 10Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Clock;
